import { API_BASE_URL, apiGetOptional } from '@/api/http';

export const getMagicLink = (query: string) =>
  apiGetOptional<{ link?: string }>(`${API_BASE_URL}${query}`);
